import { useState } from "react";
import { Gavel, Lock, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { inputCls, btnCls, toastOk } from "./RosterTab";

/* Issue-warrant mini form, opened from an NCIC hit. Serious warrants also lock
   the suspect's bank funds until the warrant is cleared. */

export default function WarrantForm({ serverId, token, demo, hit, onDone }) {
  const [reason, setReason] = useState("");
  const [serious, setSerious] = useState(false);
  const [busy, setBusy] = useState(false);

  const issue = async () => {
    if (reason.trim().length < 5) return;
    setBusy(true);
    if (demo) {
      import("sonner").then(({ toast }) => toast.success(`Warrant issued for ${hit.name} — NCIC flags WANTED`));
      onDone(); return;
    }
    try {
      const r = await api.post(`/nc/servers/${serverId}/cad/warrants`, { playercode: hit.playercode, reason: reason.trim(), serious }, { params: { token } });
      toastOk(r.data.message);
      onDone();
    } catch (e) {
      import("sonner").then(({ toast }) => toast.error(e.response?.data?.detail || "Failed"));
      setBusy(false);
    }
  };

  return (
    <div className="border border-red-500/40 bg-red-500/5 p-2.5 flex flex-col gap-1.5" data-testid="warrant-form">
      <p className="font-mono text-[8px] uppercase tracking-[0.2em] text-red-300 flex items-center gap-1"><Gavel className="w-3 h-3" /> Issue warrant — {hit.name}</p>
      <input data-testid="warrant-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (e.g. Armed robbery — armed & dangerous)" className={inputCls} />
      <label className="flex items-center gap-1.5 font-mono text-[8px] uppercase text-amber-300 cursor-pointer">
        <input data-testid="warrant-serious" type="checkbox" checked={serious} onChange={(e) => setSerious(e.target.checked)} />
        <Lock className="w-2.5 h-2.5" /> Serious — lock bank funds until cleared
      </label>
      <div className="flex gap-1.5">
        <button data-testid="warrant-issue" onClick={issue} disabled={busy || reason.trim().length < 5}
          className={`${btnCls} border-red-500/50 text-red-300 hover:bg-red-500/10 flex items-center gap-1`}>
          {busy && <Loader2 className="w-3 h-3 animate-spin" />} Issue
        </button>
        <button data-testid="warrant-cancel" onClick={onDone} className={`${btnCls} border-white/15 text-zinc-400`}>Cancel</button>
      </div>
    </div>
  );
}
